"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function extendWithFaceDescriptor(sourceObj, descriptor) {
    var extension = { descriptor: descriptor };
    return Object.assign({}, sourceObj, extension);
}
exports.extendWithFaceDescriptor = extendWithFaceDescriptor;
//# sourceMappingURL=WithFaceDescriptor.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/factories/WithFaceDescriptor.js
 ** module id = 612
 ** module chunks = 0
 **/